<template>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate">
        <v-layout wrap>
            <v-flex xs12>
                <v-switch v-model="item.enable" label="Habilitado" class="my-0 py-0" />
            </v-flex>
            <v-flex xs12 v-if="!item.id">
                <v-text-field label="E-mail" v-model="item.email" :rules="[rules.required, rules.email]" />
                <div v-if="isIntegration == false">
                    <v-text-field label="Digite a senha" v-model="item.password" min="8" :rules="[rules.required, rules.password]"
                        :append-icon="show1 ? 'visibility' : 'visibility_off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1" counter required />
                    <v-text-field label="Confirme a senha" v-model="confirmPassword" min="8" :rules="confirmPasswordRules" :append-icon="show2 ? 'visibility' : 'visibility_off'"
                        :type="show2 ? 'text' : 'password'" @click:append="show2 = !show2" counter required />
                </div>
                <div v-else>
                    <v-text-field label="Chave de acesso" v-model="item.password" min="8" :rules="[rules.required]" append-icon="refresh" type="text" @click:append="generateApiKey"
                        required />
                </div>
            </v-flex>
            <v-flex xs12 v-else>
                <v-text-field label="E-mail" v-model="item.email" disabled />
                <div v-if="isIntegration == true">
                    <v-text-field label="Chave de acesso" v-model="item.password" append-icon="refresh" type="text" @click:append="generateApiKey" />
                </div>
            </v-flex>
            <v-flex xs12 v-if="isIntegration == true">
                <v-alert icon="shield" prominent text type="error" v-if="item.id > 0"> A regra de integração não podem ser modificadas. </v-alert>
                <v-alert icon="shield" prominent text type="warning" v-else> Criação permitida apenas para usuário de integração. </v-alert>

                <v-alert icon="shield" prominent text type="warning" v-if="item.password"> Salve o código de acesso, o mesmo não poderá ser recuperado. {{ item.password }} </v-alert>
            </v-flex>
            <v-flex xs12 v-else>
                <v-autocomplete v-model="item.roles" :items="roles" item-value="key" item-text="description" label="Regras" class="my-0 py-0" deletable-chips multiple
                    small-chips />
            </v-flex>
            <v-flex xs12>
                <v-btn :loading="lock" :disabled="!valid" color="success" @click="validate" style="width: 100%;">Salvar</v-btn>
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import rules from "@/helpers/rules";

export default {
    directives: { mask },

    props: {
        itemToEdit: {
            type: Object,
        },
        lock: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            rules,
            valid: true,
            confirmPassword: null,
            show1: false,
            show2: false,
            itemClean: {
                email: "",
                password: "",
                roles: ["INTEGRATION"],
            },
            item: { ...this.itemClean },
            roles: [
                { key: "ADMIN", description: "Administrador" },
                { key: "OPERATOR", description: "Operador" },
                { key: "ADMIN_CONDOMINIUM", description: "Administrador de condomínio" },
                { key: "CLIENT", description: "Parceiro carro" },
                { key: "CLIENT_BIKE", description: "Parceiro bike" },
                { key: "USER", description: "Usuário" },
            ],
            confirmPasswordRules: [(v) => v === this.item.password || "Senha diferentes"],
        };
    },

    computed: {
        isIntegration() {
            return this.item && this.item.roles && this.item.roles.length == 1 && this.item.roles[0] == 'INTEGRATION';
        }
    },

    watch: {
        itemToEdit: {
            immediate: true,
            handler(newVal) {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                }

                if (newVal == null) {
                    this.item = { ...this.itemClean };
                } else {
                    this.item = { ...newVal, password: "" };
                }
            },
        },
    },

    methods: {
        validate() {
            if (this.$refs.form.validate()) {
                this.$emit("save", this.item);
            }
        },
        async generateApiKey() {
            const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const randomValues = new Uint8Array(64);
            window.crypto.getRandomValues(randomValues);
            this.item.password = Array.from(randomValues).map((v) => charset[v % charset.length]).join('');

            // Copia para a área de transferência
            navigator.clipboard.writeText(this.item.password)
                .then(() => {
                    this.$eventHub.$emit("msgSuccess", 'Chave de acesso copiada para a área de transferência.');
                });
        }
    },
};
</script>